import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { PagingConfig } from 'app/core/feature/rest/pagingConfig';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {

  @Input() userNotification :any;
  @Output() isRead = new EventEmitter<boolean>();
  @Output() viewAll = new EventEmitter<object>();
  @Input() pagination: PagingConfig;
  @Input() unreadNotifications: any = 0;
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    if(this.userNotification){
      this.userNotification.forEach(element => {
        if(!element.title.search("Money Request")){
          element.icon = "icon-cash"
        }else{
          element.icon = "icon-message"
          element.body = element.body.replace(" A.", " Approved.");
          element.body = element.body.replace(" V.", " Verified.");
        }
      });
    }
  }

  ngAfterViewInit(){
    if(this.userNotification){
      let data={"mark_all_read":"true"};
      this.commonService.markAllNotification(data).subscribe(x=>{
        this.isRead.emit(true);
      })
    }

  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['userNotification'].currentValue){
      this.ngOnInit();
    }
  }

  fetchAllNotification(){
    this.viewAll.emit({getAll: 1});
  }

  onScrollDown(){
    this.fetchAllNotification();
  }

  get viewAllFlag(){
    return (this.unreadNotifications == 0 && !!this.userNotification.length);
  }

  isOlderThanSevenDays(creation_date:string){
    const added_on = new Date(creation_date);
    const today = new Date()

    const oneDay = 1000 * 60 * 60 * 24;
    const diffDays = Math.floor((today.setHours(0,0,0,0) - added_on.setHours(0,0,0,0)) / oneDay);

    return diffDays > 7;
  }

  trackByNotification(index: number, item: any): any {
    return item.id ?? index;
  }
}
